
import { useAppContext } from "@/context/Context";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRouter } from "next/navigation";
import sal from "sal.js";
const BASE_URL = process.env.NEXT_PUBLIC_APP_API_URL;

const ForgotPassword = () => {
  const { isLightTheme } = useAppContext();
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    sal();

    const cards = document.querySelectorAll(".bg-flashlight");
    cards.forEach((bgflashlight) => {
      bgflashlight.onmousemove = function (e) {
        let x = e.pageX - bgflashlight.offsetLeft;
        let y = e.pageY - bgflashlight.offsetTop;

        bgflashlight.style.setProperty("--x", x + "px");
        bgflashlight.style.setProperty("--y", y + "px");
      };
    });
  }, []);
  const [formData, setFormData] = useState({
    email: "",

  });
  const [formErrors, setFormErrors] = useState({
    email: false,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setFormErrors({
      ...formErrors,
      [name]: value === false,
    });
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { email } = formData;
    if (!email) {
      setFormErrors({
        email: !email,
      });
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `${BASE_URL}/auth/forget-password`,
        {
          email,
        }
      );
      toast.success("Successfully Changed!");
      setTimeout(() => {
        router.push("/auth/signin");
      }, 1000);
    } catch (error) {
      console.error(error)
      toast.error("Failed. Please try again.");
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <>
      <ToastContainer />
      <div
        className="signup-area rainbow-section-gapTop-big"
        data-black-overlay="2"
      >
        <div className="sign-up-wrapper rainbow-section-gap">
          <div className="sign-up-box bg-flashlight">
            <div className="signup-box-top top-flashlight light-xl">

            </div>
            <div className="signup-box-bottom">
              <div className="signup-box-content">
                <h4 className="title">Forget Password</h4>
                <form onSubmit={handleSignIn}>
                  <div className="input-section mail-section">
                    <div className="icon">
                      <i className="feather-mail"></i>
                    </div>
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter email address"
                      onChange={handleInputChange}
                    />
                    {formErrors.email && (
                      <span className="error">Email is required</span>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="btn-default"
                    disabled={loading}
                    style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                  >
                    {loading ? <div className="spinner"></div> : "Send Link "}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
